import { useEffect, useState } from 'react';
import { getPaymentPlansRequest } from '../../services/network/common/payment';
import { PAYMENT_PLANS_FALLBACK } from '../../constants/paymentPlans';

let cachedPlans = null;
let pendingRequest = null;

const loadPaymentPlans = () => {
    if (!pendingRequest) {
        pendingRequest = getPaymentPlansRequest()
            .then((data) => {
                if (data && data.top) {
                    cachedPlans = { ...PAYMENT_PLANS_FALLBACK, ...data };
                }
                return cachedPlans || PAYMENT_PLANS_FALLBACK;
            })
            .catch(() => {
                pendingRequest = null;
                return PAYMENT_PLANS_FALLBACK;
            });
    }
    return pendingRequest;
};

export const formatGel = (gel) => `${gel} ₾`;

export const usePaymentPlans = () => {
    const [plans, setPlans] = useState(cachedPlans || PAYMENT_PLANS_FALLBACK);

    useEffect(() => {
        if (cachedPlans) return undefined;
        let active = true;
        loadPaymentPlans().then((next) => {
            if (active) setPlans(next);
        });
        return () => {
            active = false;
        };
    }, []);

    return plans;
};
